import React, { useState, useEffect } from "react";
import { Trans, withTranslation } from "react-i18next";
import JsSIP from "jssip";
import {
  OverlayToaster,
  Button,
  Position,
  Icon,
  Tag,
  ControlGroup,
  Classes,
  Alert,
  Popover,
} from "@blueprintjs/core";
import { authenticatedGetFetch } from "../../utils/AuthenticatedFetch";
import { AudioControl } from "./AudioControl";
import CallState, {
  CS_IN_PROGRESS,
  CS_ON_HOLD,
  CS_NO_CALL,
} from "./CallStatus";
import i18n from "../../i18n";
import { getSetting } from "../Settings/InstallationSettings";
import { ValidateIPaddress } from "../../utils/validation";

var device_name = undefined;
var prev_device_name = undefined;
var TheToast = undefined;
export var ua = null;
export let asteriskconnection = false;

function MyCall(props) {
  const [Toast, setToast] = useState(undefined);
  const [Micro, setMicro] = useState(undefined);
  const [Session, setSession] = useState(undefined);
  const [SipAudio, setSipAudio] = useState(undefined);
  const [Status, setStatus] = useState(props.status);

  if (Toast === undefined) {
    setToast(props.toast);
    setSession(props.session);
    TheToast = props.toast;
    setSipAudio(new Audio());
  }

  useEffect(() => {
    if (Session.direction === "outgoing") {
      Session.connection.addEventListener("addstream", (e) => {
        SipAudio.srcObject = e.stream;
        SipAudio.play();
      });
    }
    if (Session !== undefined) {
      Session.on("progress", () => {
        console.log(Toast, " Call PROGRESS");
        props.call_status(CS_NO_CALL);
        setStatus(CS_NO_CALL);
      });
      Session.on("hold", () => {
        console.log(Toast, " Call on HOLD");
        setStatus(CS_ON_HOLD);
        props.call_status(CS_ON_HOLD);
      });
      Session.on("unhold", () => {
        console.log(Toast, " Call UNHOLD");
        setStatus(CS_IN_PROGRESS);
        props.call_status(CS_IN_PROGRESS);
      });
      Session.on("confirmed", () => {
        console.log(Toast, " Call CONFIRMED");
        setStatus(CS_IN_PROGRESS);
        props.call_status(CS_IN_PROGRESS);
      });
      Session.on("failed", () => {
        console.log(Toast, " Call FAILED");
        setStatus(CS_NO_CALL);
        props.call_status(CS_NO_CALL);
        props.dismiss(Toast);
      });
      Session.on("ended", () => {
        console.log(Toast, " Call ENDED");
        setStatus(CS_NO_CALL);
        props.call_status(CS_NO_CALL);
        props.dismiss(Toast);
      });
    }
    return () => {
      // component unmount.
      if (Session) Session.terminate();
    };
  }, []);

  useEffect(() => {
    if (Micro) Session.mute();
    else Session.unmute();
  }, [Micro]);

  if (Session !== undefined) {
    return (
      <ControlGroup vertical={true}>
        <div>
          {Session.direction === "incoming" && (
            <Trans>intercom call from</Trans>
          )}
          {Session.direction === "outgoing" && <Trans>intercom call to</Trans>}
          <Tag>{Toast}</Tag>
        </div>
        <AudioControl
          onVolumeChange={(volume) => (SipAudio.volume = volume)}
          onInputChange={(input) => {
            SipAudio.setSinkId(input);
            SipAudio.play();
          }}
          onOutputChange={(output) => {
            SipAudio.setSinkId(output);
            SipAudio.play();
          }}
          pull_data={(data) => setMicro(data)}
        />
        <div style={{ textAlign: "center" }}>
          <CallState status={Status} />
          <Button
            icon="phone"
            intent="danger"
            style={{ transform: "rotate(135deg)", borderRadius: "200px" }}
            onClick={() => {
              Session.terminate();
              TheToast = Toast;
            }}
          />
          {Status === CS_NO_CALL && Session.direction === "incoming" && (
            <Button
              icon="phone"
              intent="success"
              style={{ borderRadius: "200px" }}
              onClick={() => {
                Session.answer();
                TheToast = Toast;
                Session.connection.addEventListener("addstream", (e) => {
                  SipAudio.srcObject = e.stream;
                  SipAudio.play();
                });
              }}
            />
          )}
          {Status === CS_IN_PROGRESS && (
            <Button
              icon="pause"
              intent="warning"
              style={{ borderRadius: "200px" }}
              onClick={() => {
                Session.hold({ useUpdate: false });
                TheToast = Toast;
              }}
            />
          )}
          {Status === CS_ON_HOLD && (
            <Button
              icon="play"
              intent="primary"
              style={{ borderRadius: "200px" }}
              onClick={() => {
                Session.unhold({ useUpdate: false });
                TheToast = Toast;
              }}
            />
          )}
        </div>
      </ControlGroup>
    );
  }
}

class ClientPhonie extends React.Component {
  constructor(props) {
    super(props);

    const domain = getSetting("phonie server IP", "");
    const port = getSetting("phonie wss port", "8089");

    this.toasterRef = React.createRef(null);
    this.state = {
      ringing: false,
      call_session: undefined,
      call_time: 0,
      call_start_time: 0,
      call_status: CS_NO_CALL,
      session_status: "DISCONNECTED",
      endpoints: undefined,
      NoMicro: false,
      domain: domain,
      socket: ValidateIPaddress(domain)
        ? new JsSIP.WebSocketInterface(
            "wss://" + domain + ":" + port + "/asterisk/ws"
          )
        : null,
      password: "webrtc_client",
      phone_number: "webrtc_client",
    };
  }

  register() {
    var configuration = {
      sockets: [this.state.socket],
      uri: "sip:" + this.state.phone_number + "@" + this.state.domain,
      register: true,
      password: this.state.password,
      contact_uri: "sip:SUPERVISION@" + this.state.domain,
    };

    if (this.state.socket) {
      ua = new JsSIP.UA(configuration);

      /* Session States */
      ua.on("connected", (e) => {
        console.log("agent is connected");
        this.setState({ session_status: "CONNECTED" });
      });

      ua.on("disconnected", (e) => {
        console.log(
          "agent is disconnected",
          e.code ? ("with code ", e.code) : " "
        );
        this.setState({ session_status: "DISCONNECTED" });

        if (e.code === 1015) window.location.href = "/ow/view/certs/asterisk";
      });

      ua.on("registered", (e) => {
        console.log("agent is registered");
        this.setState({ session_status: "CONNECTED" });
        asteriskconnection = true;
      });

      ua.on("unregistered", (e) => {
        console.log("agent is unregistered");
        this.setState({ session_status: "DISCONNECTED" });
        asteriskconnection = false;
      });

      ua.on("registrationFailed", (e) => {
        console.log("agent register failed : " + e.request + e.response);
        this.setState({ session_status: "DISCONNECTED" });
      });

      ua.on("newRTCSession", (e) => {
        var session = e.session;
        this.setState({ call_session: session });

        /* Call States */
        session.on("confirmed", () => {
          this.setState({ call_status: CS_IN_PROGRESS });
          this.setState({ ringing: false });
        });
        session.on("failed", (e) => {
          this.setState({ ringing: false });
          this.setState({ call_session: undefined });
          this.setState({ call_status: CS_NO_CALL });
          device_name = undefined;
          if (e.cause.includes("User Denied Media Access"))
            this.setState({ NoMicro: true });
        });
        session.on("ended", () => {
          this.setState({ ringing: false });
          this.setState({ call_session: undefined });
          this.setState({ call_status: CS_NO_CALL });
          device_name = undefined;
        });
        if (session.direction === "incoming") {
          if (this.state.call_status === CS_NO_CALL)
            this.setState({ ringing: true });
          this.setState({ call_status: CS_NO_CALL });
        }
        if (session.direction === "outgoing") {
          this.setState({ call_status: CS_IN_PROGRESS });
        }
      });
      ua.start();
    } else {
      console.warn("can't open webrtc client without valid socket");
    }
  }

  call_status(status) {
    this.setState({ call_status: status });
  }

  componentDidMount() {
    if (
      localStorage.getItem("perm_phonie") === "true" &&
      this.state.socket !== undefined
    ) {
      this.register();
      authenticatedGetFetch("/phonie/endpoints", (endpoints) =>
        this.setState({ endpoints: endpoints })
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !this.state.NoMicro &&
      this.state.call_session !== undefined &&
      (this.state.call_session !== prevState.call_session ||
        prevState.call_status !== this.state.call_status)
    ) {
      try {
        if (this.state.call_session.direction === "outgoing")
          device_name =
            this.state.endpoints[
              this.state.call_session._remote_identity._uri._user
            ]["equipment_name"];
        else if (this.state.call_session.direction === "incoming")
          device_name =
            this.state.endpoints[
              this.state.call_session._remote_identity._display_name
            ]["equipment_name"];
      } catch (e) {
        device_name = "new card";
      }
      this.toasterRef.current.show(
        {
          icon: "headset",
          isCloseButtonShown: false,
          timeout: 6000000, // 100 minutes max, using 0 dismiss the Toast at mouse hover
          message: (
            <MyCall
              session={this.state.call_session}
              toast={device_name}
              toaster={this.toasterRef.current}
              status={this.state.call_status}
              call_status={(status) => this.call_status(status)}
              dismiss={(key) => this.toasterRef.current.dismiss(key)}
            />
          ),
        },
        TheToast !== undefined && device_name === prev_device_name
          ? TheToast
          : device_name
      );
      prev_device_name = device_name;
    }
  }

  render() {
    return (
      <span>
        <Alert
          confirmButtonText={i18n.t("cancel")}
          isOpen={this.state.NoMicro}
          onClose={() => this.setState({ NoMicro: false })}
          canEscapeKeyCancel={true}
          canOutsideClickCancel={true}
          intent="danger"
          icon="headset"
        >
          <p>
            <Trans>no microphone or speaker available</Trans>
          </p>
        </Alert>
        {this.state.session_status === "CONNECTED" ? (
          <Popover
            placement="auto"
            interactionKind="hover"
            minimal={true}
            content={
              <Tag intent="success">
                {" "}
                <Trans>connnected</Trans>
              </Tag>
            }
          >
            <Button
              minimal={true}
              intent="success"
              onClick={() => {
                if (ua) ua.stop();
              }}
            >
              <Icon icon="symbol-circle" />
            </Button>
          </Popover>
        ) : (
          <Popover
            placement="auto"
            interactionKind="hover"
            intent="danger"
            minimal={true}
            content={
              <Tag intent="danger">
                {" "}
                <Trans>disconnnected</Trans>
              </Tag>
            }
          >
            <Button
              minimal={true}
              onClick={() => {
                if (ua) ua.start();
              }}
            >
              <Icon icon="offline" />
            </Button>
          </Popover>
        )}
        <OverlayToaster
          className={Classes.TOAST_CONTAINER}
          usePortal={true}
          ref={this.toasterRef}
          position={Position.RIGHT_BOTTOM}
        />

        {this.state.ringing && this.state.call_status === CS_NO_CALL && (
          <audio loop={true} src="sound/phone.ogg" autoPlay={true} />
        )}
      </span>
    );
  }
}

export default withTranslation()(ClientPhonie);
